import React from 'react';

import {
    Popup,
    Header,
    LogoWrapper,
    Logo,
    HeaderContent,
    Name,
    HeaderTitle,
    Body,
} from './styled';

const PopupPackage = ({ name, text, logoNoBackground, color, children, onClose, isOpen }) => {
    return (
        <Popup onClose={onClose} isOpen={isOpen} closeColor='#fff'>
            <Header style={{ 'background': color }}>
                {logoNoBackground && <LogoWrapper>
                    <Logo src={logoNoBackground} alt={name}></Logo>
                </LogoWrapper> }
                <HeaderContent>
                    <Name>{name}</Name>
                    <HeaderTitle>{text}</HeaderTitle>
                </HeaderContent>
            </Header>
            <Body>
                {children}
            </Body>
        </Popup>
    );
};

export default PopupPackage;
